<template>
  <div>
    <v-autocomplete
      :background-color="backgroundColor"
      :outlined="outlined"
      :items="items"
      item-text="itemName"
      item-value="id"
      v-model="items"
      :label="$t('components.ajaxFile.label')"
      append-icon="cloud_upload"
      @focusin.native="dialog = true"
      :error-messages="validationMessage"
      multiple
      :menu-props="{ value: false }"
    >
      <template slot="selection" slot-scope="data">
        <v-chip small :selected="data.selected" :key="JSON.stringify(data.item)" @input="data.parent.selectItem(data.item)">
          {{ data.item.itemName }}
        </v-chip>
      </template>
    </v-autocomplete>
    <v-dialog v-model="dialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t("components.ajaxFile.headline") }}</span>
        </v-card-title>
        <v-card-text v-for="item in items" :key="item.id">
          <v-card
            v-bind:class="{
              'green accent-1': item.uploadedSize === item.fileSize
            }"
          >
            <v-card-text>
              <v-row class="mx-0">
                <v-col
                  ><strong>{{ item.itemName }}</strong> <br />({{ Number.parseFloat(item.fileSize / 1000).toFixed(1) }} KB) {{ item.status }}
                </v-col>
                <v-spacer />
                <v-tooltip top>
                  <template #activator="{on}">
                    <v-btn v-on="on" icon @click="downloadFile(item)" :disabled="$store.getters['Ajax/loading']">
                      <v-icon>cloud_download</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("global.downloadFile") }}
                </v-tooltip>
                <v-tooltip top v-if="!readonly">
                  <template #activator="{on}">
                    <v-btn v-on="on" icon @click="removeFile(item)" :disabled="$store.getters['Ajax/loading']">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </template>
                  {{ $t("global.removeFile") }}
                </v-tooltip>
              </v-row>
              <v-progress-linear v-if="item.uploadedSize !== item.fileSize" :value="(item.uploadedSize / item.fileSize) * 100" />
            </v-card-text>
          </v-card>
        </v-card-text>
        <v-row v-if="!readonly" class="mx-0">
          <v-col class="ma-3">
            <form ref="inputForm">
              <v-btn class="primary" @click="$refs.fileInput.click()">{{ $t("global.choseFile") }}</v-btn>
              <input style="display: none" type="file" v-if="uploadButton" @change="upload($event)" ref="fileInput" :accept="accept" />
            </form>
          </v-col>
        </v-row>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import fileDownload from "../../repository/downloadFile";

export default {
  name: "AjaxFile",
  props: {
    backgroundColor: {
      default: null,
      required: false
    },
    outlined: {
      default: null,
      required: false
    },
    readonly: {
      default: false,
      required: false
    },
    accept: {
      type: String,
      required: false,
      default: "*"
    },
    items: {
      type: Array,
      required: true
    },
    validationMessage: {
      type: Array,
      default: function() {
        return [];
      }
    },
    assignment: {
      required: false,
      default: null
    },
    assign_id: {
      required: false,
      default: null
    },
    assign_shortcut: {
      required: false,
      default: null
    }
  },
  data: () => ({
    newId: -1,
    uploadButton: true,
    dialog: false,
    validationError: false,
    //validationMessage: [],
    //items: [],
    search: "",
    uploadedFile: null,
    loading: false
  }),
  watch: {
    selectModel(val) {
      this.onChange(val);
    }
  },
  computed: {
    select: {
      set: function(value) {
        this.$emit("update:selectModel", value);
      },
      get: function() {
        return this.selectModel;
      }
    }
  },
  methods: {
    upload(event) {
      const dataToSend = new FormData();
      const file = event.target.files[0];
      if (file.size > 1024 * 1024 * 3) {
        this.$store.dispatch("alertDialog", {
          content: this.$t("components.file.fileToLarge.content"),
          title: this.$t("components.file.fileToLarge.title")
        });
      } else {
        dataToSend.append("filename", "test");
        dataToSend.append("file", file);
        if (this.assignment) {
          dataToSend.append("assignment", this.assignment);
        }
        if (this.assign_id) {
          dataToSend.append("assign_id", this.assign_id);
        }
        if (this.assign_shortcut) {
          dataToSend.append("assign_shortcut", this.assign_shortcut);
        }
        this.uploadButton = false;
        this.$nextTick(() => {
          this.uploadButton = true;
        });
        const newItem = {
          id: this.newId--,
          itemName: file.name,
          status: this.$t("global.loading"),
          fileSize: file.size,
          uploadedSize: 0
        };
        this.items.push(newItem);
        const temp = this;
        this.axios({
          url: "file/upload-file",
          data: dataToSend,
          method: "POST",
          onUploadProgress: function(progressEvent) {
            newItem.uploadedSize = progressEvent.loaded;
          }
        })
          .then(function(result) {
            newItem.status = temp.$t("global.loaded");
            newItem.id = result.data.id;
            temp.$emit("fileUploaded", newItem);
          })
          .catch(function(error) {
            console.log("Error Result"); // console logi w razie problemów żeby użytkownik mógł opisać problem
            console.log(error.message);
            console.log(error.response);
            console.log(error.request);
            temp.removeFile(newItem);
            temp.$store.dispatch("alertDialog", {
              content: temp.$t("components.file.errorDialog.content") + error.response.status,
              title: temp.$t("components.file.errorDialog.title")
            });
          });
      }
    },

    removeFile(item) {
      this.items.splice(this.items.indexOf(item), 1);
      this.$emit("fileRemoved", item);
      //TODO ajax remove request?
    },

    downloadFile(item) {
      fileDownload("file/download-file?fileId=" + item.id);
    }
  },
  created() {}
};
</script>

<style scoped>
.chip--small {
  height: 22px;
}
</style>
